import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const PREFIX = 'LandingPageHeaders';

const classes = {
  pagetitle: `${PREFIX}-pagetitle`,
  pagesubtitle: `${PREFIX}-pagesubtitle`,
  headerRoot: `${PREFIX}-headerRoot`
};

const Root = styled('div')({
  [`& .${classes.pagetitle}`]: {
    marginTop: '18px',
    marginBottom: '0px'
  },
  [`& .${classes.pagesubtitle}`]: {
    marginTop: '18px',
    fontWeight: 400
  },
  [`&.${classes.headerRoot}`]: {
    marginTop: '10%'
  }
});

export interface LandingPageHeadersProps {
  headers: Headers;
  logo: (...props: Record<string, string>[]) => JSX.Element;
}

export interface Headers {
  title?: string;
  description?: string;
  link?: string;
}

const LandingPageHeaders = ({ headers, logo }: LandingPageHeadersProps) => {
  const CompanyLogo = logo;

  return (
    <Root className={classes.headerRoot}>
      <Typography
        variant="h2"
        gutterBottom
        align="center"
        className={`${classes.pagetitle} customHeader`}
      >
        <CompanyLogo fontSize="inherit" />
      </Typography>

      <Typography
        variant="h2"
        gutterBottom
        align="center"
        className={`${classes.pagetitle} customHeader`}
        data-testid="landingpage-title"
      >
        {headers && headers.title}
      </Typography>
      <Typography
        variant="h6"
        gutterBottom
        align="center"
        className={`${classes.pagesubtitle} customHeader`}
        data-testid="landingpage-description"
      >
        {headers && headers.description}
      </Typography>
    </Root>
  );
};

export default LandingPageHeaders;
